import React from 'react';
import Services from './Services';
import ServicesChartsDataProvider from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../maps/subtitleMap';

const ServicesWrapper = ({ queryConfig, module, children }) => {
    return (
        <ServicesChartsDataProvider
            module={module}
            queryConfig={queryConfig}
            subtitlesMap={subtitlesMap}
        >
            <Services />
            {children}
        </ServicesChartsDataProvider>
    );
};

export default ServicesWrapper;
